import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
// import { useNavigate } from 'react-router-dom'
import { clearCreatedInvoiceAssignment, fetchInvoiceAssignments } from '../../../store/actions/invoicesActions'
import { SET_SUCCESS } from '../../../store/types'
import ModalDialog from '../../layouts/ModalDialog'
import DataTable from '../../elements/DataTable'
import { debounce, tableHeadersFields } from '../../../utils'
import Loader from '../../elements/Loader'
import ArrowUpTrayIcon from '../../elements/icons/ArrowUpTrayIcon'
import SearchField from '../../elements/SearchField'
import AssignedInvoice from '../invoices/AssignedInvoice'
import AssignInvoiceToStudent from '../invoices/AssignInvoiceToStudent'
import EmptyState from '../../elements/EmptyState'
import EnablePartPayment from '../invoices/EnablePartPayment'
import AddInvoiceDiscount from '../invoices/AddInvoiceDiscount'
import InvoiceStatus from '../../elements/InvoiceStatus'
import PercentBadgeIcon from '../../elements/icons/PercentBadgeIcon'
import SquaresGridIcon from '../../elements/icons/SquaresGridIcon'

const StudentInvoices = ({student, reload, setReload}) => {
    const dispatch = useDispatch()
    const invoicesSelector = useSelector(state => state.invoices)
    // const navigate = useNavigate()
    const [filters] = useState(`student=${student._id}`);
    const [pagination, setPagination] = useState({
        page: 1,
        perPage: 25
    });
    useEffect(() => {
        dispatch(fetchInvoiceAssignments(filters, pagination.page, pagination.perPage))
        if(invoicesSelector.createdInvoiceAssignment !== null){
          dispatch(clearCreatedInvoiceAssignment())
          dispatch({
            type: SET_SUCCESS,
            payload: 'Invoice assignment queued successfully!'
          })
          setCreatingInvoiceAssignment(false)
        }
        return () => {
          
        };
      }, [dispatch, filters, pagination.page, pagination.perPage, reload, invoicesSelector.createdInvoiceAssignment]);
    
      const [creatingInvoiceAssignment, setCreatingInvoiceAssignment] = useState(false);
    
      const transactionColumnWidths = {
        invoiceCode: 'w-2/12',
        nameAndDescription: 'w-4/12',
        fees: 'w-1/12',
        totalAmount: 'w-2/12',
        status: 'w-2/12',
        date: 'w-1/12',
    }
        
    const tableOptions = {
      selectable: false,
      clickableRows: true,
      rowAction: (index)=>{setActiveInvoiceAssignment(invoicesSelector.invoiceAssignments?.assignments[index])}
    }
    
    const columnDataStyles = {}
    
    // const FeesDisplay = ({fees}) => {
    //   return (
    //     <div className='w-full'>
    //       {fees.slice(0,2).map((fee, feeIndex)=>(
    //         <span key={feeIndex} className='p-[5px] mr-[5px] mb-[5px] inline-block text-xs text-gray-600 bg-gray-100 rounded'>
    //           {fee.fee.name} (x{fee.quantity})
    //         </span>
    //       ))}
    //       {fees.length > 2 && <span className='p-[5px] mr-[5px] mb-[5px] inline-block text-xs text-gray-400 bg-gray-100 rounded'>+{fees.length - 2} more</span>}
    //     </div>
    //   )
    // }
    
    const cleanupData = (dataSet) => {
        if(!dataSet) return []
        const data = []
        dataSet.forEach((item, itemIndex) => {
            data.push(
                {
                  invoiceCode: <p className='mt-[5px] font-medium flex items-center'>{item.invoice.invoiceCode}
                        {item?.discount?.confirmed && <span title="Available discount" className='w-[30px] h-[30px] rounded-full flex items-center justify-center bg-green-500 bg-opacity-10 ml-[5px]'>
                            <PercentBadgeIcon className={`w-[20px] h-[20px] text-green-600`} />
                        </span>}
                        {item?.partPayments?.confirmed && <span title="Part payments enabled" className='w-[30px] h-[30px] rounded-full flex items-center justify-center bg-blue-500 bg-opacity-10 ml-[5px]'>
                            <SquaresGridIcon className={`w-[20px] h-[20px] text-blue-600`} />
                        </span>}
                    </p>,
                  nameAndDescription: <div>
                    <p className='text-black text-sm font-[500]'>{item.invoice.name}</p>
                    <p className='text-xs text-gray-400'>{item.invoice.description}</p>
                  </div>,
                  fees: `${item.invoice.fees.length} fees`,
                  totalAmount: <p className='font-space-grotesk'>₦{(item.discountedTotal/100).toLocaleString()}</p>,
                  status: <InvoiceStatus status={item.status} />,
                  date: `${new Date(item.createdAt).toDateString()} - ${new Date(item.createdAt).toLocaleTimeString()}`,
                },
            )
        })
    
        return data
    }

    const searchInvoiceAssignments = debounce((term) => {
        if(!term || term === '') setReload(reload + 1)
        dispatch(fetchInvoiceAssignments(`invoiceName=${term}&invoiceCode=${term}`, 0, 0))
    })

    const [activeInvoiceAssignment, setActiveInvoiceAssignment] = useState(null);

    const [enablingPartPayment, setEnablingPartPayment] = useState(false)
    
    const openEnablingPartPayment = (assignment) => {
        setActiveInvoiceAssignment(null)
        setEnablingPartPayment(true)
        setTimeout(() => {
            setActiveInvoiceAssignment(assignment)
        }, 300);
    }

    const [addingDiscount, setAddingDiscount] = useState(false)

    const openAddingDiscount = (assignment) => {
        setActiveInvoiceAssignment(null)
        setAddingDiscount(true)
        setTimeout(() => {
            setActiveInvoiceAssignment(assignment)
        }, 300);
    }

    return (
        <>
        <div className="w-full">
            <div className='pb-3 mb-2'>
                <div className="w-full mx-auto">
                    <div className='w-full flex items-center justify-between'>
                        <div className='w-2/3'>
                            <h4 className='font-medium text-lg text-gray-700'>Invoices</h4>
                            <div className=''>
                                <p className='text-gray-500 mt-1 text-sm'>
                                    Below is a list of payments to Vaatia College
                                </p>
                            </div>
                        </div>
                        <button onClick={()=>{setCreatingInvoiceAssignment(true)}} className='rounded px-4 py-3 mt-4 text-sm text-purple-100 bg-vcm-purple transition duration-200 border border-vcm-purple hover:bg-vcm-light-purple hover:text-vcm-purple flex items-center justify-center gap-x-2'>
                            Assign an Invoice for this student
                        </button>
                    </div>

                    <div className='w-full flex items-center justify-between my-5 p-2 rounded-md border'>
                        <div className='w-full'>
                            {/* <InvoicesFilters applyFilters={(filters)=>{
                                console.log('filters => ', filters)
                                setFilters(filters)
                            }} 
                            /> */}
                        </div>
                        <div className='w-full flex flex-row-reverse gap-x-2'>
                            <button onClick={()=>{}} className={`text-gray-700 px-3 py-2 hover:bg-gray-100 transition duration-200 text-sm flex items-center justify-center gap-x-2 bg-gray-200 rounded border`}>
                                <ArrowUpTrayIcon className={`w-5 h-5`} />
                                Export Invoices
                            </button>
                            <div className='w-[350px]'>
                                <SearchField 
                                    placeholderText={`Search for invoice by name or invoice code`}
                                    showResultsDropDown={false}
                                    triggerSearch={(term)=>{searchInvoiceAssignments(term)}}
                                    performingSearch={invoicesSelector.loadingInvoiceAssignments}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className=''>
                {invoicesSelector?.loadingInvoiceAssignments
                    ? 
                        <div className='w-full'>
                            <Loader />
                        </div>
                    : 
                       invoicesSelector.invoiceAssignments?.assignments?.length > 0 ? <>
                            <DataTable
                                tableHeaders={tableHeadersFields(cleanupData(invoicesSelector?.invoiceAssignments?.assignments)[0]).headers} 
                                tableData={cleanupData(invoicesSelector?.invoiceAssignments?.assignments)} 
                                columnWidths={transactionColumnWidths}
                                columnDataStyles={columnDataStyles}
                                allFields={tableHeadersFields(cleanupData(invoicesSelector?.invoiceAssignments?.assignments)[0]).fields}
                                onSelectItems={()=>{}}
                                tableOptions={tableOptions}
                                pagination={{
                                    perPage: pagination.perPage, 
                                    currentPage: pagination.page,
                                    totalItems: invoicesSelector.invoiceAssignments.total,
                                }}
                                changePage={(page) => {setPagination({...pagination, ...{page: page}})}}
                                updatePerPage={(perPage) => {setPagination({...pagination, ...{perPage: perPage}})}}
                            />
                        </>
                        :
                        <div>
                            <EmptyState emptyStateText={`No invoices have been assigned to ${student.firstName} ${student.lastName} yet`} />
                        </div>
                }
            </div>
        </div>

        <ModalDialog
            shown={creatingInvoiceAssignment} 
            closeFunction={()=>{setCreatingInvoiceAssignment(false)}} 
            actionFunction={()=>{}} 
            actionFunctionLabel={``}
            dialogTitle={`Assign an invoice to ${student.fullName}`}
            maxWidthClass='max-w-2xl'
            hideActions={true}
        >
            <AssignInvoiceToStudent 
                student={student} 
                reload={()=>{setReload(reload + 1)}} 
                closeFunction={()=>{setCreatingInvoiceAssignment(false)}} 
            />
        </ModalDialog>

        {activeInvoiceAssignment && <ModalDialog
            shown={activeInvoiceAssignment !== null && !enablingPartPayment && !addingDiscount} 
            closeFunction={()=>{setActiveInvoiceAssignment(null)}} 
            actionFunction={()=>{}} 
            actionFunctionLabel={``}
            dialogTitle='Invoice Details'
            maxWidthClass='max-w-4xl'
            hideActions={true}
        >
            <AssignedInvoice 
                assignment={activeInvoiceAssignment}
                invoiceId={activeInvoiceAssignment.invoice._id} 
                closeFunction={()=>{setActiveInvoiceAssignment(null)}} 
                startAddDiscount={(assignment)=>{openAddingDiscount(assignment)}}
                startEnablePartPayment={(assignment)=>{openEnablingPartPayment(assignment)}}
            />
        </ModalDialog>}

        {activeInvoiceAssignment && <ModalDialog
            shown={activeInvoiceAssignment !== null && enablingPartPayment} 
            closeFunction={()=>{setEnablingPartPayment(false)}} 
            actionFunction={()=>{}} 
            actionFunctionLabel={``}
            dialogTitle='Enable Part payments'
            maxWidthClass='max-w-lg'
            hideActions={true}
        >
            <EnablePartPayment 
                assignment={activeInvoiceAssignment}
                closeFunction={()=>{setEnablingPartPayment(false)}}
            />
        </ModalDialog>}

        {activeInvoiceAssignment && <ModalDialog
            shown={activeInvoiceAssignment !== null && addingDiscount} 
            closeFunction={()=>{setAddingDiscount(false)}} 
            actionFunction={()=>{}} 
            actionFunctionLabel={``}
            dialogTitle='Add a discount'
            maxWidthClass='max-w-lg'
            hideActions={true}
        >
            <AddInvoiceDiscount
                assignment={activeInvoiceAssignment}
                closeFunction={()=>{setAddingDiscount(false)}} 
            />
        </ModalDialog>}
    </>
    )
}

export default StudentInvoices